<h2 mat-dialog-title translate>dialog.test.title</h2>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-content>
  <form [formGroup]="exigenciasForm">
    <mat-checkbox
      id="checkExigenciaTestDialog"
      color="accent"
      [checked]="checked"
      (change)="checked = !checked"
      aria-label="Aceptar exigencia"
      name="checkExigencia"
      (click)="onclick()"
      formControlName="checkExigencias"
    >
      <span>{{ text }}</span>
    </mat-checkbox>
  </form>
</mat-dialog-content>
<mat-divider class="dialog__divider--top"></mat-divider>
<mat-dialog-actions>
  <button id="exitButtonTestDialog" mat-stroked-button color="accent" class="btnMobile" (click)="exit()">
    <span>{{ 'dialog.password.button2' | translate | uppercase }}</span>
  </button>
  <button
    id="acceptButtonTestDialog"
    mat-flat-button
    color="accent"
    class="btnMobile"
    [disabled]="exigenciasForm.invalid"
    (click)="accept()"
  >
    <span> {{ 'dialog.test.button.continue' | translate | uppercase }} </span>
  </button>
</mat-dialog-actions>
